import { useState, useEffect } from 'react';
import { getPartnerOffers } from '@/lib/firebase/queries/offers';
import type { PartnerOffer } from '@/components/partner/types';

export function usePartnerOffers() {
  const [offers, setOffers] = useState<PartnerOffer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      setLoading(true);
      const partnerOffers = await getPartnerOffers();
      // Only show active offers
      const activeOffers = partnerOffers.filter(offer => offer.status === 'active');
      setOffers(activeOffers);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch offers'));
    } finally {
      setLoading(false);
    }
  };

  return {
    offers,
    loading,
    error,
    refreshOffers: fetchOffers
  };
} 